function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "FashionHotspots-logo_beeldmerk");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.64,38.86h-29A62.17,62.17,0,0,0,.84,72.49h32.8Z",
  fill: "#00a09b"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M120.08,38.86H43V72.49H91.44v45a62.32,62.32,0,0,0,28.64-78.59Z",
  fill: "#00a09b"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.64,29.52h81.69a62.33,62.33,0,0,0-106,0Z",
  fill: "#00a09b"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M82.1,81.83H43v39.76a62.31,62.31,0,0,0,39.12-.14Z",
  fill: "#00a09b"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.64,81.83H3.13a62.46,62.46,0,0,0,30.51,35.83Z",
  fill: "#00a09b"
});

var SvgFashionHotspotsLogoBeeldmerk = function SvgFashionHotspotsLogoBeeldmerk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 124.67,
    height: 124.67,
    viewBox: "0 0 124.67 124.67",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFashionHotspotsLogoBeeldmerk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FashionHotspots-logo_beeldmerk.970e22c7.svg";
export { ForwardRef as ReactComponent };